import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import fb from "../../../assets/fb.png";
import google from "../../../assets/google.png";
import signupBg from "../../../assets/signup_bg.jpg";
import { getLoginInfo } from "../../../redux/reducers/loginReducer";
import "../Signup/Signup.css";
import { TbEyeCancel, TbEyeCheck } from "react-icons/tb";

export default function Login() {
  const dispatch = useDispatch();
  let navigate = useNavigate();
  const location = useLocation();

  const {
    register,
    handleSubmit,
    formState: { inputErrors },
  } = useForm();
  const { loginInfo, errors } = useSelector((state) => state.loginInfo);
  const [showPassword, setShowPassword] = useState(false);
  const onSubmit = (data) => {
    // console.log(data)
    dispatch(getLoginInfo(data));
  };

  useEffect(() => {
    if (loginInfo.status === 200) {
      toast.success("Login Successfull", {
        position: "top-right",
        autoClose: 600,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      // pages like reset password / OTP pass a destination; going "back" would return to them
      const from = location.state?.from;
      if (from) {
        navigate(from, { replace: true });
      } else {
        window.history.back();
      }

      setTimeout(() => {
        // navigate("/")
        window.location.reload();
      }, 500);
    }
  }, [loginInfo]);

  return (
    <section className="relative">
      <div className="relative z-10 p-4 sm:p-8">
        <form
          className="max-w-lg mx-auto bg-gray-50 rounded-lg shadow-lg py-5 sm:py-10 px-4 sm:px-8  space-y-4"
          onSubmit={handleSubmit(onSubmit)}
        >
          <h3 className="text-gray-800 font-semibold text-center text-lg sm:text-xl">
            Login To Your Account
          </h3>
          <div className="space-y-2">
            {/* phone */}
            <div className="form-group cmb-10">
              <label className="pure-material-textfield-outlined">
                <input
                  type="text"
                  placeholder=" "
                  {...register("phone", { required: true })}
                />
                {/* <input type='text' placeholder='' id='name' {...register("name", {required: true, maxLength: 30})} /> */}
                <span className="text-gray-700 font-medium">
                  Email or Phone Number
                </span>
              </label>
            </div>
            {/*
						{inputErrors.phone && inputErrors.phone.type === "required" && <p className='text-xs py-2 font-semibold text-red-600 text-center'>Email or Phone number is required</p>} */}
            {/* password */}
            <div className="form-group cmb-10">
              <label className="pure-material-textfield-outlined">
                <input
                  type={showPassword ? "text" : "password"}
                  placeholder=" "
                  {...register("password", { required: true })}
                />
                <span className="text-gray-700 font-medium">Password</span>
                {showPassword ? (
                  <TbEyeCancel
                    onClick={() => setShowPassword(false)}
                    className="h-5 w-5 text-gray-500 hover:text-gray-700 absolute right-4 top-1/2 -translate-y-1/2"
                  />
                ) : (
                  <TbEyeCheck
                    onClick={() => setShowPassword(true)}
                    className="h-5 w-5 text-gray-500 hover:text-gray-700 absolute right-4 top-1/2 -translate-y-1/2"
                  />
                )}
              </label>
            </div>
            {/* {inputErrors.password && inputErrors.password.type === "required" && <p className='text-xs py-2 font-semibold text-red-600 text-center'>Password is required</p>} */}
          </div>

          <div className="flex flex-col justify-center space-y-6">
            <div className="space-y-2">
              <input
                className="bg-gradient-to-r from-[#2995FC]  to-[#3076CE] py-2 px-6 rounded-lg text-white text-base w-full cursor-pointer"
                type="submit"
                value="Login"
              />
              <Link
                to="/forget-password"
                className="text-sm font-normal text-[#0073FA] cursor-pointer"
              >
                Forgot password?
              </Link>
            </div>
            <p className="text-lg text-center font-semibold text-gray-500">
              Or Continue With
            </p>
            <div className="flex justify-between items-center gap-x-6 ">
              <figure className="flex justify-center items-center h-16 sm:h-24 w-full bg-white rounded-lg shadow-md cursor-pointer border border-gray-200">
                <img
                  className="h-8 sm:h-12 w-full object-contain rounded-lg"
                  src={google}
                  alt="product"
                />
              </figure>
              <figure className="flex justify-center items-center h-16 sm:h-24 w-full bg-white rounded-lg shadow-md cursor-pointer border border-gray-200">
                <img
                  className="h-8 sm:h-12 w-full object-contain rounded-lg"
                  src={fb}
                  alt="product"
                />
              </figure>
            </div>
            <p className="font-semibold text-center space-x-3 text-gray-600">
              <span>Don’t have an account?</span>
              <Link to="/signup" className="text-[#0073FA]">
                Sign Up
              </Link>
            </p>
          </div>
        </form>
      </div>

      {/* signup background */}
      <figure className="absolute inset-0 z-0">
        <img
          className="h-full w-full object-contain sm:object-cover rounded-lg"
          src={signupBg}
          alt="product"
        />
      </figure>
      <ToastContainer />
    </section>
  );
}
